import { useMemo as r } from "../../../../external/preact/hooks/dist/hooks.module.js";
import i from "./usePagination.js";
const u = (e) => e.next, C = (e, s) => {
  const g = r(() => {
    let t = 0;
    return { getPageCount: () => t, getPageParams: (a, n) => ({ offset: (a - 1) * n }), resetPageCount: () => {
      t = 0;
    }, updatePagination: (a, n, o) => {
      u(o) && o.next && (t = Math.max(t, a + 1));
    } };
  }, []);
  return i(g, e, s);
};
export {
  C as default,
  u as hasNextPage
};
